import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/image/loginbg.png'
import _imports_1 from '@/assets/image/earth.png'
import _imports_2 from '@/assets/image/loginuser.png'
import _imports_3 from '@/assets/image/loginpassword.png'


const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "login-box" }
const _hoisted_3 = { class: "login-box-content-right" }

import {ref, reactive, onMounted} from 'vue'
  import type { FormInstance } from 'element-plus'
  import { useRouter } from 'vue-router'
  import { useStore } from "vuex";
  import { encrypt } from "../../utils/rsa.js"
  import { ElMessage } from 'element-plus'
  import {isPhone} from '@/utils/validate'
  import {getArea, getRoles} from "@/api/jurisdiction";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

  const ruleFormRef = ref<FormInstance>()
const router = useRouter()
const store = useStore()
const validateUsername = (rule: any, value: any, callback: any) => {
  if (!value) {
      ElMessage.error('请输入用户名')
    // return callback(new Error('请输入用户名'))
  }
  callback()
}
const validatePass = (rule: any, value: any, callback: any) => {
  if (value === '') {
    // callback(new Error('请输入密码'))
     ElMessage.error('请输入密码')
  }else if(value.length>20){
    callback(new Error('密码长度最多不超过20位'));
  }else {
    callback()
  }
}
const valiPhone = (rule: any, value: any, callback: any) => {
    console.log(!isPhone(value))
    callback()
    // if(!isPhone(value)){
    //   callback(new Error('请输入正确的11位手机号'));
    // }else{
    //   callback()
    // }
}
const ruleForm = reactive({
  username: '',
  password: '',
  remember: false
})

const rules = reactive({
  password: [{ validator: validatePass, trigger: 'blur' }],
  username: [{ validator: valiPhone, trigger: 'blur' }],
})

const submitForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return
  formEl.validate(async (valid) => {
    if (valid) {
      // 登录
      await store.dispatch('user/login', ruleForm)
      if(ruleForm.remember){
        let rememberCount = JSON.stringify(ruleForm)
        localStorage.setItem("rememberCount",rememberCount)
      }else{
        localStorage.removeItem("rememberCount")
      }
      router.push({
        path: '/'
      })
    } else {
      console.log('error submit!')
      return false
    }
  })
}
  onMounted(() => {
    const pwd = localStorage.getItem("rememberCount")
    const JSONpwd = JSON.parse(pwd)
    if(JSONpwd !== null && JSONpwd.remember){
      ruleForm.username = JSONpwd.username
      ruleForm.password = JSONpwd.password
      ruleForm.remember = JSONpwd.remember
    }
  })

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[9] || (_cache[9] = _createElementVNode("img", {
      src: _imports_0,
      class: "bg"
    }, null, -1)),
    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "login-left" }, [
      _createElementVNode("div", { class: "icon-area" }, [
        _createElementVNode("img", {
          src: _imports_1,
          alt: ""
        })
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "box-title" }, "CRM智能管理系统", -1)),
        _createVNode(_component_el_form, {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          model: ruleForm,
          "status-icon": "",
          rules: rules,
          "label-width": "0",
          class: "login-form"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "",
              prop: "username",
              class: "input_bottom"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: ruleForm.username,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ruleForm.username) = $event)),
                  placeholder: "用户名",
                  type: "text",
                  onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (submitForm(ruleFormRef.value)), ["enter","native"]))
                }, {
                  prepend: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createElementVNode("img", {
                      src: _imports_2,
                      alt: "",
                      style: {"width":"20px","height":"24px"}
                    }, null, -1),
                    _createElementVNode("span", { class: "in_span" }, "|", -1)
                  ])),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "",
              prop: "password",
              class: "input_bottom"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (submitForm(ruleFormRef.value)), ["enter","native"])),
                  placeholder: "密码",
                  modelValue: ruleForm.password,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ruleForm.password) = $event)),
                  type: "password",
                  "suffix-icon": "none"
                }, {
                  prepend: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createElementVNode("img", {
                      src: _imports_3,
                      alt: "",
                      style: {"width":"20px","height":"24px"}
                    }, null, -1),
                    _createElementVNode("span", { class: "in_span" }, "|", -1)
                  ])),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { style: {"width":"100%"} }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (submitForm(ruleFormRef.value))),
                  class: "login-btn"
                }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode("登录")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ]))
}
}

})